// Shared inline styles for print-only pages (see components/PrintShell).

export const printLabel = {
  fontSize: '11px', fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: '0.08em', color: '#666', marginBottom: '4px',
} as const

export const printTh = {
  textAlign: 'left', padding: '6px 8px 6px 0', fontSize: '12px', fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: '0.05em',
} as const

export const printTd = { padding: '8px 8px 8px 0', borderBottom: '1px solid #eee', verticalAlign: 'top' } as const

export function formatPrintDate(iso: string): string {
  return new Date(iso).toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' })
}
